import { analyzePrivClient } from "../api";

class EvolutiveCrossService {
  constructor() {}

  /**
   *
   * @param {number} clientId
   * @param {string} data Id's das perguntas e.g 1,2,3
   * @returns Promise que será dispachada para os reducers atualizarem o estado posteriormente.
   */
   fetchCrossedQuestions(clientId, data) {
    const promise = analyzePrivClient.post(
      `pesquisas/clientes/${clientId}/cruzamentos/simples/perguntas/principais/perguntas/cruzadas`,
      data
    );

    return promise;
  }

  fetchCrossedQuestionsAlternatives(
    surveyId,
    analyzeIds,
    clientId,
  ) {
    const promise = analyzePrivClient.get(`pesquisas/questionarios/cliente/${clientId}/pesquisa/${surveyId}/pergunta/${analyzeIds}/alternativas/new`)
    return promise;
  }

  // TODO: ADICIONAR COMENTÁRIO
  fetchAlternativesAndCrossedQuestions(
    surveyId,
    analyzeId,
    clientId,
    withAlternatives = true,
    withCrossedQuestions = true
  ) {
    const promise = analyzePrivClient.get(
      `pesquisas/${surveyId}/clientes/${clientId}/cruzamentos/simples/perguntas/${analyzeId}/resumo?alternativasPrincipais=${withAlternatives}&perguntasCruzadas=${withCrossedQuestions}`
    );

    return promise;
  }

  // TODO: ADICIONAR COMENTÁRIO
  fetchSurveysWithCrossedQuestions(
    clientId,
    query = null,
    initInterval = null,
    endInterval = null,
    excludeSurveyId = null
  ) {
    const queryParam = query ? `query=${query}` : "";
    const initIntervalParam = initInterval
      ? `intervaloInicio=${initInterval}`
      : "";
    const endIntervalParam = endInterval ? `intervaloFim=${endInterval}` : "";
    const excludeSurveyIdParam = excludeSurveyId
      ? `excludePesquisa=${excludeSurveyId}`
      : "";

    const queryParams = [
      queryParam,
      initIntervalParam,
      endIntervalParam,
      excludeSurveyIdParam,
    ]
      .filter((param) => param)
      .map((q, index) => (index > 0 ? `&${q}` : q))
      .join("");

    const finalQuery = queryParams ? `?${queryParams}` : "";

    const promise = analyzePrivClient.get(
      `pesquisas/clientes/${clientId}/cruzamentos/simples${finalQuery}`
    );

    return promise;
  }

  /**
   * @param {number} clientId Id do cliente
   * @param {array} groupQuestions Grupo de perguntas combinadas
   * @returns Promise que quando resolvida contém a lista de alternativas para cada grupo enviado.
   */
  getAlternativesByGroupQuestions(clientId, groupQuestions) {
    const endpoint = `/pesquisas/questionarios/clientes/${clientId}/pesquisas/perguntas/alternativas/grupo`;
    const promise = analyzePrivClient.post(endpoint, groupQuestions);
    
    return promise;
  }

  /**
   * Realiza a requisição para criação de uma configuração de evolutivo de cruzamentos e retorna uma promise
   * @param {*} clientId 
   * @param {*} surveyId 
   * @param {*} payload 
   */ 
  createConfig(
    clientId,
    surveyId,
    payload
  ) {
    const promise = analyzePrivClient.post(
      `/pesquisas/${surveyId}/clientes/${clientId}/resultados/evolutivos/cruzamentos/configuracoes`,
      payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    return promise;
  }

  /**
   * Realiza a requisição para recuperação da lista de configurações do evolutivo de cruzamentos
   * @param {*} clientId 
   * @param {*} surveyId 
   * @param {*} questionId 
   */
  listConfigs(clientId, surveyId, questionId) {
    const resourceLocation = `/pesquisas/${surveyId}/clientes/${clientId}/resultados/evolutivos/cruzamentos/configuracoes/perguntas/principais/${questionId}`;
    const result = analyzePrivClient.get(resourceLocation);

    return result;
  }

  /**
   * Realiza a requisição para recuperar os resultados do evolutivo de cruzamentos dado uma configuração
   * @param {*} configId 
   */
  fetchConfigResult(configId, crossedQuestionId, alternativeId) {
    const resourceLocation = `pesquisas/resultados/evolutivos/cruzamentos/configuracoes/${configId}/perguntas/cruzadas/${crossedQuestionId}/alternativas/${alternativeId}`;
    const result = analyzePrivClient.get(resourceLocation);
    return result;
  }

  /**
   * @param {*} configId  Id da configuração de um evolutivo de cruzamento
   * @returns lista de filtros (perguntas secundárias e suas alternativas)
   */
  fetchListFilters(configId) {
    const resourceLocation = `/pesquisas/resultados/evolutivos/cruzamentos/configuracoes/${configId}/perguntas/cruzadas/`;
    const result = analyzePrivClient.get(resourceLocation);
    return result;
  }

}

export const evolutiveCrossService = new EvolutiveCrossService();
